module.exports = __webpack_public_path__ + "static/media/romanian-government.af33ec1d.png";